import { render, staticRenderFns } from "./ServiceModule.vue?vue&type=template&id=bedc4fa8&"
import script from "./ServiceModule.vue?vue&type=script&lang=js&"
export * from "./ServiceModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports